// extracted by mini-css-extract-plugin
export default {"paywallIcon":"U0T8BDETyy3JM7vaKPwe__paywallIcon___"};